

















import Vue, { PropType } from 'vue';
import { convertDateToAmericanFormat } from '../../lib/utils';

export default Vue.extend({
    props: {
        ratingsData: {
            type: Array as PropType<object>,
        },
        loading: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            stars: [
                undefined,
                require('@/assets/icons/star_face_sad.svg'),
                undefined,
                require('@/assets/icons/star_face_ok.svg'),
                undefined,
                require('@/assets/icons/star_face_happy.svg'),
            ],
            headers: [
                { text: 'Name', value: 'fullName' },
                { text: 'Date', value: 'updated' },
                { text: 'Route', value: 'routeName' },
                { text: 'Rating', value: 'rating' },
                { text: 'Details', value: 'suggestionsChosen', width: 350 },
                { text: 'Comments', value: 'freeText', width: 300 },
            ],
            data: [],
        };
    },
    methods: {
        convertDateToAmericanFormat,
    },
});
